import * as React from 'react';
import { StickyCallToAction } from '@grandvisionhq/common';
import '../../../../../context/actions.js';
import '../../../../../context/reducer.js';
import { useProductData } from '../../../../../context/product-context-hooks.js';
import '../../../../../context/ProductContext.js';
import '../../../../../context/CmsContext.js';
import { StickyPriceView } from '../../../../StickyCta/components/StickyPriceView.js';
import { useSunglassesPriceFrom } from '../../hooks/use-sunglasses-price-from.js';
import { SunglassesCTA } from '../SunglassesCTA/SunglassesCTA.js';

const SunglassesStickyCTA = ({ className  })=>{
    const { displayPrice  } = useProductData();
    const { fromPricePrefix  } = useSunglassesPriceFrom();
    return /*#__PURE__*/ React.createElement(StickyCallToAction, {
        className: className,
        button: /*#__PURE__*/ React.createElement(SunglassesCTA, null),
        price: /*#__PURE__*/ React.createElement(StickyPriceView, {
            displayPrice: displayPrice,
            prefix: fromPricePrefix
        })
    });
};

export { SunglassesStickyCTA };
//# sourceMappingURL=SunglassesStickyCTA.js.map
